import { render, staticRenderFns } from "./fullGiftClassification.vue?vue&type=template&id=08ff6682&scoped=true"
import script from "./fullGiftClassification.vue?vue&type=script&lang=js"
export * from "./fullGiftClassification.vue?vue&type=script&lang=js"
import style0 from "./fullGiftClassification.vue?vue&type=style&index=0&id=08ff6682&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff6682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ff6682')) {
      api.createRecord('08ff6682', component.options)
    } else {
      api.reload('08ff6682', component.options)
    }
    module.hot.accept("./fullGiftClassification.vue?vue&type=template&id=08ff6682&scoped=true", function () {
      api.rerender('08ff6682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/fullGift/components/fullGiftClassification.vue"
export default component.exports